import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FormInput from '../FormInput';
import { formatNumber } from '../../utils';

function CompoundSubtraction({ name, references, constants, allowNegative = true, autoCalculate = false, ...props }) {
    const [hasBeenCalculated, setHasBeenCalculated] = useState(false);
    const {
        watch,
        setValue,
        clearErrors,
        trigger,
        getValues,
        formState: { isSubmitted, dirtyFields },
    } = useFormContext();

    useEffect(() => {
        const calculateValue = () => {
            const [initial, ...values] = getValues([...references]);
            if (constants) values.push(...constants);

            const summedNegatives = values.reduce((prev, current) => formatNumber(prev, true) + formatNumber(current, true), 0);
            const allNumbers = !Number.isNaN(Number(initial)) && !Number.isNaN(summedNegatives);
            let result = allNumbers ? initial - summedNegatives : 0;
            if (!allowNegative && result < 0) result = 0;

            // calling setValue does not call onChange
            // validation methods need to manually be called
            clearErrors([name]);
            const { rounding } = props.props;
            setValue(name, parseFloat(result.toFixed(rounding ?? 1)), { shouldDirty: true });
            setHasBeenCalculated(true);
            if (isSubmitted) {
                trigger([name]);
            }
        };

        if (references.some((ref) => dirtyFields[ref]) || hasBeenCalculated || autoCalculate) {
            calculateValue();
        }
    }, [...watch([...references])]);

    return <FormInput name={name} {...props} />;
}

export default CompoundSubtraction;
